import { CoreModel } from './core-model';
import { BaseMultiLanguageModelInterface } from './base-multi-language-model.interface';
import { MultiLanguageIdentityInterface } from './multi-language-identity.interface';
import { Expose } from "@nts/std/serialization";
import { IdentityInterface } from '@nts/std/interfaces';


export class BaseMultiLanguageModel<TMLIdentity extends IdentityInterface & MultiLanguageIdentityInterface> extends CoreModel<TMLIdentity> implements BaseMultiLanguageModelInterface {

    private _languageCode: string;

    /**
     * Codice lingua (in formato en-GB, it-IT)
     */
    @Expose()
    get languageCode(): string {
        return this.getValueForIdentityValue<string>(() => this._languageCode, 'languageCode');
    }
    set languageCode(value: string) {
        this.setValueForIdentityValue<string>(() => { this._languageCode = value; }, value, 'languageCode');
    }

}
